import { InternalAxiosRequestConfig } from 'axios';
import { getActiveProject } from '@/lib/project-context/project-context-bindings';

export const projectIdRequestInterceptor = (config: InternalAxiosRequestConfig) => {
  const platformProjectId = getActiveProject()?.platformProjectId;
  if (platformProjectId) {
    config.headers['x-selected-project-id'] = platformProjectId;
  }
  return config;
};
